uic-tab {
  align-items: center;
  background-color: var(--uic-tab-background-color);
  box-sizing: border-box;
  color: var(--uic-tab-text-color);
  cursor: pointer;
  display: flex;
  outline: 2px solid transparent;
  outline-offset: -2px;
  padding: 0 20px 0 14px;
  position: relative;
  transition: all 0.1s ease;
  user-select: none;

  // Border styles controlled by CSS variables from tab-list
  border-bottom: var(--uic-tab-border-bottom, none);
  border-right: var(--uic-tab-border-right, none);
  border-top: var(--uic-tab-border-top, none);
  border-left: var(--uic-tab-border-left, none);

  .uic-tab__label {
    overflow: hidden;

    /* stylelint-disable declaration-property-value-disallowed-list, value-no-vendor-prefix, property-no-vendor-prefix */
    /* webkit not supported by IE, but currently no other good solution is available for multiline text with ellipsis.  */
    > slot-fb {
      -webkit-box-orient: vertical;
      display: block;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /* stylelint-enable declaration-property-value-disallowed-list, value-no-vendor-prefix, property-no-vendor-prefix */
  }

  &[icon] .uic-tab__label,
  [slot='icon'] ~ .uic-tab__label,
  [name='icon'] ~ .uic-tab__label {
    margin-left: 8px;
  }

  slot-fb {
    display: flex;
  }
}

@media (hover: hover) {
  uic-tab:hover {
    background-color: var(--uic-tab-background-color-hover);
  }
}

uic-tab:focus {
  color: var(--uic-tab-text-color-focus);
  outline-color: var(--uic-tab-border-color-focus);
}

uic-tab:active {
  color: var(--uic-tab-text-color-active);
}

uic-tab:disabled {
  color: var(--uic-tab-text-color-disabled);
  font-weight: normal;
}

uic-tab[selected] {
  color: var(--uic-tab-text-color-selected);

  border-bottom: var(--uic-tab-border-bottom-selected, var(--uic-tab-border-bottom, none));
  border-right: var(--uic-tab-border-right-selected, var(--uic-tab-border-right, none));
  border-top: var(--uic-tab-border-top-selected, var(--uic-tab-border-top, none));
  border-left: var(--uic-tab-border-left-selected, var(--uic-tab-border-left, none));
  background: var(--uic-tab-background-selected, var(--uic-tab-background-color));
}

uic-tab:not(:last-of-type) {
  border-right: var(--uic-tab-border-right-not-last, var(--uic-tab-border-right, none));
}

// #region BREAKPOINTS
uic-tab {
  @media #{$breakpoint_tablet} {
    height: 68px;
    min-width: 64px;
  }

  @media #{$breakpoint_desktop} {
    height: 82px;
    min-width: 77px;
  }

  @media #{$breakpoint_tablet_small} {
    min-width: 48px;
  }
}

uic-tab[vertical] {
  width: 100%;

  @media #{$breakpoint_tablet} {
    height: 52px;
  }

  @media #{$breakpoint_desktop} {
    height: 63px;
  }

  @media #{$breakpoint_tablet_small} {
    height: 39px;
  }
}

// #endregion

// #region ANIMATIONS

@keyframes loading-tab-horizontal {
  0% {
    left: 0;
    width: 8px;
  }

  5% {
    left: 0;
    width: 8px;
  }

  50% {
    left: 0;
    width: 100%;
  }

  95% {
    left: calc(100% - 8px);
    width: 8px;
  }

  100% {
    left: calc(100% - 8px);
    width: 8px;
  }
}

@keyframes loading-tab-vertical {
  0% {
    height: 8px;
    top: 0;
  }

  5% {
    height: 8px;
    top: 0;
  }

  50% {
    height: 100%;
    top: 0;
  }

  95% {
    height: 8px;
    top: calc(100% - 8px);
  }

  100% {
    height: 8px;
    top: calc(100% - 8px);
  }
}

// #endregion
